import React, { useState, useEffect, useRef, memo } from 'react';
import classes from './FieldBuilder.module.css';
import ModalComponent from '../OptionsModal/OptionsModal';
import FieldOptionsBuilder from '../FieldOptionsBuilder/FieldOptionsBuilder';
import FieldOptionsSelector from '../FieldOptionsSelector/FieldOptionsSelector';
import SelectionModalComponent from '../SelectionModal/SelectionModal';
import apiGatewayService from '../../../common/services/apiGatewayService';
import FieldsDependentSelector from '../FieldsDependentSelector/FieldsDependentSelector';
import validationService from '../../../common/validationService.service';
import localStorageService from '../../../common/services/localStorage.service';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Button, IconButton, InputLabel, TextField, Checkbox, 
 FormControlLabel, FormControl, Select, MenuItem, Typography , Box,  Toolbar} from '@mui/material';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import BackupIcon from '@mui/icons-material/Backup';
import LowPriorityIcon from '@mui/icons-material/LowPriority'; 
import utilityFunctions from '../../../common/services/utilityFunctions';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import ListIcon from '@mui/icons-material/List';
import StyleIcon from '@mui/icons-material/Style';
import FormatListNumberedIcon from '@mui/icons-material/FormatListNumbered';
import TableColumns from '../../TableColumns/TableColumns';
import AutoAwesomeMotionIcon from '@mui/icons-material/AutoAwesomeMotion';
import MultiCheckBoxInputs from '../../MultiCheckBoxInputs/MultiCheckBoxInputs';
import DataObjectIcon from '@mui/icons-material/DataObject';
import FieldConfigBuilder from '../FieldConfigBuilder/FieldConfigBuilder';
import MessageIcon from '@mui/icons-material/Message';
import MessageStrip from '../MessageStrip/MessageStrip';
import CustomAlert from '../../CustomAlert/CustomAlert';
import DeleteConfirmation from '../../DeleteConfirmation/DeleteConfirmation';
import {initialFieldState, FieldJSONTemplate} from '../../../common/configurations/json-configurations'
import FieldVisibilitySelector from '../FieldVisibilitySelector/FieldVisibilitySelector';
import FieldIconButton from './FieldIconButton';
import PreviewIcon from '@mui/icons-material/Preview';
import FieldControlTypeSelector from '../FieldControlTypeSelector/FieldControlTypeSelector';
import FieldValidValuesBuilder from '../FieldValidValuesBuilder/FieldValidValuesBuilder';
import FieldActionButton from './FieldActionButton';
import { fieldInputFieldStyle, fieldCheckboxFieldStyle, updateButtonStyle } from '../../../common/CSS/css-configs';
import {
  submitFieldCSS, removeFieldCSS, toggleEditArrowCSS, fieldInputCSS
} from './FieldBuilder.styles';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import { VisibilityOutlined } from '@mui/icons-material';
import TableFieldsPopup from '../TableFieldsPopup/TableFieldsPopup';


const mandatoryFieldKeys = ['name', 'label', 'type', 'dataType', 'length', 'required', 'wrapping','visible'];

const validationValues = ['none','phone', 'email'];

const controlTypeValues = {
  "":"",
  "Advance Location Selection": "AdvancedLocationSearch",
  "AGFMA Site Selector": "AGFMASiteSearch",
  "AGFMA Facility Selector": "AGFMAFacilitySearch",
  "Configurable Table Selector": "TableSearch",
  "Advance Equipment Selection": "AdvancedEquipmentSearch"
}


const FieldBuilder = (props) => {
  useEffect(() => {
    // console.log("field: ", field);
    setFieldKeys(Object.keys(initialFieldState.fieldDefinition));
    // console.log("Props field builder: ",props);
    if(Object.keys(props.field).length !== 0){
      if(props.field?.validValues?.method === 'PVV'){
        props.field.fieldDefinition.options = getOptionName(props.field?.validValues?.configuration?.api);
        setOptionsEnabled(true);
      }
      setField(props.field);
      handleExtrasOnInput(props.field);
    } else if (Object.keys(field || {}).length !== 0) {
      console.log("Dont re render field already is assigned value");
    } else {
      // setField({});
      setField(FieldJSONTemplate);
    }
    if(props.isForm) {
      setIsForm(true);
    };

    if(props.isEdit){
      setIsEdit(true);
      setFieldId(props.fieldId);
    }

    if(props.isView){
      console.log("We are inside isView: ", props.isView);
      setIsView(true);
      setFieldId(props.fieldId);
    }

    if (props.isForm && props.checkForErroInField) {
      checkForErrorsInField(props.field);
    }

    setIsTableField(props?.isTableField || false);

    const user = localStorageService.getObject('user');
    setCogntioUser(user);
    setIsOnlyReadAccess(utilityFunctions.checkIfOnlyReadAccess(user));
    // console.log("Check if only user access: ",utilityFunctions.checkIfOnlyReadAccess(user) )
  }, [props]); 

  const [typeOptions] = useState({
    text: ["string"],
    textarea: ["string"],
    selection: ["object", "array", "string"],
    dropdown: ["object", "array", "string"],
    checkbox: ["boolean"],
    number: ["integer", "float", "double"],
    upload: ["base64", "string", "file"],
    date: ["string", "date", "datetime"],
    table: ["object", "array", "string"],
    signature: ["base64"],
    time: ["string", "date", "datetime"],
    multiCheckbox: ["object"],
    staticContent: ["string"],
    method: ["object"]
  });

  const [fieldTemplate] = useState(initialFieldState);

  const [field, setField] = useState();
  const [changedValue, setChangedValue] = useState(false);
  const [optionsEnabled, setOptionsEnabled] = useState(false);
  const [dependentEnabled, setdependentEnabled] = useState(false);
  const [allFields, setAllFields] = useState([{name: ''}]);
  const [isForm, setIsForm] = useState(false);
  const [cogntioUser, setCogntioUser] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isArrowDown, setIsArrowDown] = useState(false);
  const [isOnlyReadAccess, setIsOnlyReadAccess] = useState(false);
  const [optionsModalOpen, setOptionsModalOpen] = useState(false);
  const [dependentModalOpen, setdependentModalOpen] = useState(false);
  const [tableEnabled, setTableEnabled] = useState(false);
  const [tableModalOpen, setTableModalOpen] = useState(false);
  const [multiCheckBoxInputModalOpen, setMultiCheckBoxInputModalOpen] = useState(false);
  const [multiCheckBoxEnabled, setMultiCheckBoxEnabled] = useState(false);
  const [fieldId, setFieldId] = useState(null);
  const [isView, setIsView] = useState(false);
  const [configEnabled, setConfigEnabled] = useState(false);
  const [configModalOpen, setConfigModalOpen] = useState(false);
  const [isUpload, setIsUpload] = useState(false);
  const [messageStripModalOpen, setMessageStripModalOpen] = useState(false);
  const [fieldDescription, setFieldDescription] = useState('');
  const [disableControlType, setDisableControlType] = useState(false);
  const [fieldKeysWithError, setFieldKeysWithError] = useState([]);
  const [displayAlert, setDisplayAlert] = useState(false);
  const [alertType, setAlertType] = useState('');
  const [alertMessage, setAlertMessage] = useState('');
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isBarcodeSelectionEnabled, setIsBarcodeSelectionEnabled] =  useState(false);
  const [fieldVisibilityModalOpen, setFieldVisibilityModalOpen] = useState(false);
  const [currentMethod, setCurrentMethod] = useState("");
  const [fieldKeys, setFieldKeys] = useState([]);
  const [isTableField, setIsTableField] = useState(false);
  const fieldReference = useRef([]);


  const convertToCapital = (value) => {
    return `${value[0].toUpperCase()}${value.slice(1)}`;
  };

  const handleInputChange = (e) => {
    console.log('field: ', field);
    const { name, value, type } = e.target;
    const newValue = type === 'number' ? parseInt(value) : value;

    setChangedValue(true);
    console.log("Input Change →", name, "=", newValue);

    setField(prev => {
      // clone existing fieldDefinition (safe immutability)
      const updatedFieldDefinition = {
        ...prev.fieldDefinition,
        [name]: newValue
      };

      // handle "validate"
      if (name === 'validate') {
        updatedFieldDefinition.validate = { type: value };
      }

      // handle "type"
      if (name === 'type') {
        const selectedType = value;
        updatedFieldDefinition.dataType = typeOptions[selectedType][0];

        setOptionsEnabled(['dropdown', 'selection'].includes(selectedType));
        setTableEnabled(['table'].includes(selectedType));
        setMultiCheckBoxEnabled(['multiCheckbox'].includes(selectedType));
        setConfigEnabled(['staticContent'].includes(selectedType));
        setIsUpload(['upload'].includes(selectedType));
        setDisableControlType(selectedType !== 'text');

        // optional: reset upload-specific keys
        if (selectedType === 'upload') {
          console.log("Inside upload check");
          debugger
          if (fieldTemplate.fieldDefinition.url === undefined) {
            fieldTemplate.fieldDefinition.url = '';
            fieldTemplate.fieldDefinition.area = '';
            setFieldKeys(Object.keys(fieldTemplate.fieldDefinition))
          }
        } else {
          console.log("Inside upload check else");
          delete fieldTemplate.fieldDefinition.url;
          delete fieldTemplate.fieldDefinition.area;
          setFieldKeys(Object.keys(fieldTemplate.fieldDefinition));
        }
      }

      // handle "controlType"
      if (name === 'controlType') {
        setIsBarcodeSelectionEnabled(
          value === 'AdvancedLocationSearch' || value === 'AdvancedEquipmentSearch'
        );
      }

      // handle "method"
      if (name === 'method') {
        setCurrentMethod(value);
      }

      fieldReference.current = {
        ...prev,
        fieldDefinition: updatedFieldDefinition
      };

      // return a new state object with new reference
      return {
        ...prev,
        fieldDefinition: updatedFieldDefinition
      };
    });
  };


  const handleMouseOut = () => {
    console.log("MOuse out event!!");

    if(changedValue){
      if(isForm || isTableField){
        const fieldToUpdateInSection = fieldReference.current;
        removeOptionalKeys(fieldToUpdateInSection)
        props.updateFieldsArray(fieldToUpdateInSection, props.indexFieldArray);
      }
      setChangedValue(false);
    }
  };

const handleCheckboxChange = (e) => {
  const { name, checked } = e.target;

  setField(prev => {
    const updatedFieldDefinition = {
      ...prev.fieldDefinition,
      [name]: checked
    };

    const newFieldObj = {
      ...prev,
      fieldDefinition: updatedFieldDefinition
    };

    fieldReference.current = newFieldObj;

    return newFieldObj;
  });

  setChangedValue(true);
};



  const handleRemoveField = () => {
    setField(initialFieldState);
    if(isForm){
      props.updateFieldsArray(undefined, props.indexFieldArray);
    };
    setIsDeleteModalOpen(false);
  };

  const handleRemoveFieldFromTableFields = () => {
    if(isTableField){
      props.updateFieldsArray(undefined, props.indexFieldArray);
    };
  };

  const removeOptionalKeys = (field) => {
    delete field?.fieldDefinition?.options;
    if (field?.fieldDefinition?.placeholdertext === '') {
      delete field?.fieldDefinition.placeholdertext; 
    }

    if (field?.fieldDefinition?.description === ''){
      delete field?.fieldDefinition.description;
    }

    if (field?.descriptionName === ''){
      delete field?.fieldDefinition.descriptionName;
    }

    // console.log("controlType: ", field?.controlType);
    //Check for barcode based on values
    if (field?.fieldDefinition?.controlType === '' || disableControlType) {
      delete field?.fieldDefinition.controlType;
    }

    // console.log("check control type: ", field?.fieldDefinition.controlType);
    // console.log("isBarcodeSelectionEnabled: ", isBarcodeSelectionEnabled);
    
    if (field?.validValues?.configuration?.controlType ==='AdvancedLocationSearch'){
    
    } else if (field?.validValues?.configuration?.controlType === 'AdvancedEquipmentSearch') {

    } else if (isBarcodeSelectionEnabled) {
   
    } else{ 
      
      delete field?.fieldDefinition.barcode;
    }

    if (field?.fieldDefinition.config === '') {
      delete field?.fieldDefinition.config;
    }

    if ( field?.fieldDefinition.api && Object.keys(field?.fieldDefinition.api).length === 0) {
      delete field?.fieldDefinition.api;
    } 
    if (!optionsEnabled && field?.api && Object.keys(field?.api).length !== 0){
      delete field?.fieldDefinition.api;
    }
    if(field?.fieldDefinition.dependent === ''){
      delete field.visible.dependent;
    }
    if (field?.fieldDefinition.type!=='table') {
      if(field?.tableColumns) {
        if(field?.fieldDefinition.tableColumns.length > 0){
          delete field?.fieldDefinition.tableColumns;
        }
      }
    };

    if (field?.fieldDefinition.type!=='multiCheckbox') {
      if(field?.multiCheckBoxInputs) {
        if(field?.fieldDefinition.multiCheckBoxInputs.length > 0){
          delete field?.fieldDefinition.multiCheckBoxInputs;
        }
      }
    };

    if (!configEnabled && field?.config && Object.keys(field?.config).length !== 0){
      delete field?.fieldDefinition.config;
    };

    if (!field['validate']?.type || field['validate'].type === 'none' ) {
      delete field['validate'];
    };

    if (field?.fieldDefinition.sessionID === ''){
      delete field['sessionID'];
    };

    if (field?.fieldDefinition.type==='upload'){
      field["url"] = "rest/case-interaction/getPresignedURL";
      field["area"] = "SRA_ATTACHMENTS"; 
    } else {
      delete field["url"];
      delete field["area"]; 
    }

    // Add logic for handling removal of not required validvalues
    // Also remove valid values if not a dropdown or selection
    if (['dropdown', 'selection'].includes(field?.fieldDefinition?.type)) {
      const config = field?.validValues?.configuration;

      if (config && typeof config === "object") {
        switch (currentMethod) {
          case "PVV":
            // For PVV → remove API-related configuration only if exists
            if ("controlType" in config) delete config.controlType;
            if ("values" in config) delete config.values;
            break;

          case "API/Special services":
            // For API/Special services → remove API and values if they exist
            if ("api" in config) delete config.api;
            if ("values" in config) delete config.values;
            break;

          case "Config":
            // For Config → remove controlType and API if they exist
            if ("controlType" in config) delete config.controlType;
            if ("api" in config) delete config.api;
            break;

          default:
            console.warn("Unknown method; nothing to remove.");
        }
      } else {
        console.warn("No validValues.configuration object found to clean up.");
      }
    } else {
      delete field['validValues']
    }
    // delete field['sessionID'];

    if (field?.fieldDefinition?.type !== 'table') {
      delete field?.fieldDefinition?.tableFields
    }

    console.log("field: ", field);

  };  

  const handleSubmitField = async () => {
    const displayName = field.fieldDefinition.name;
    const currentField = field;
    console.log("Field to submit before removal: ", currentField);
    removeOptionalKeys(field);
    const fieldObject = {
        displayName: displayName,
        field: field
    };
    console.log("Field to submit: ", fieldObject);
    const isFieldValid = checkForErrorsInField(field.fieldDefinition);
    if (!isFieldValid) {
      // if (validationService.hasEmptyKeys(fieldObject)) {
      setField(currentField); 
      // alert('Field keys can not be empty!');
      // props.setAlertMessageAndPopup(
      setAlertMessageAndPopupFields(
          {
            message: 'Error in submitting field: mandatory values can not be empty!',
            type: 'error'
          }
      );
    } else {
         console.log("Submitting field here");
        fieldObject['fieldDescription'] = field?.description || '';
        try {
          let response;
          console.log("isEdit: ", isEdit);
          console.log("fieldId: ", fieldId);
          console.log("field object: ", fieldObject);
          if (isEdit) {
            response = await apiGatewayService.putFieldsData(fieldId, fieldObject);
            if (isForm) {
              setAlertMessageAndPopupFields(
                {
                  message: 'Field edited successfully!',
                  type: 'success'
                });
            } else {
              props.handleClose({
                message: 'Field edited successfully!',
                type: 'success'
              });
            }

          } else {
            response = await apiGatewayService.postFieldsData(fieldObject);
            if (isForm){
              setAlertMessageAndPopupFields(
                {
                  message: 'Field created successfully!',
                  type: 'success'
                });
            } else {
              props.handleClose({
                message: 'Field created successfully!',
                type: 'success'
              });
            }

          }
          if(response.data.errorName && response.data.errorName === 'KeyExistsAlready' ){
            alert("Field with same name already exists!!!");
          } else {
  
          }

        } catch (error) {
          console.log("Error in submitting field ", error);
          // props.setAlertMessageAndPopup({
          //   message: 'Error in creating/updating field!',
          //   type: 'error'
          // });
          setField(currentField); 
        }
    };
  };

  const getOptionName = (api) => {
    if(api.url) {
      return api.url.split('/')[1].split('.')[0];
    }
    return '';
  };

  const [modalIsOpen, setModalIsOpen] = useState(false);

  const closeModal = () => {
    setModalIsOpen(false);
    setOptionsModalOpen(false);
    setdependentModalOpen(false);
    setTableModalOpen(false);
    setMultiCheckBoxInputModalOpen(false);
    setConfigModalOpen(false);
    setMessageStripModalOpen(false);
    setFieldVisibilityModalOpen(false);
  };

  // const fieldKeys = Object.keys(fieldTemplate.fieldDefinition.fieldDefinition);

  // console.log("fieldKeys: ", fieldKeys);

  const excludeFirstElement = (inputString) => {
    const parts = inputString.split('/');
    parts.shift();
    return parts.join('/');
  };
  
  const generateApiObjectForField = (option) => {
    const url = excludeFirstElement(option.path);
    return {
      url,
      label: "VALID_VALUE_DESCRIPTION",
      value: "VALID_VALUE_ID",
    };
  };

const submitOptionsIntoField = (apiOrValue) => {
  const method = currentMethod;
  console.log("Received options input:", apiOrValue, "Method:", method);
  setChangedValue(true);

  const updatedField = { ...(field || {}) };

  if (!updatedField.validValues) updatedField.validValues = {};
  if (!updatedField.validValues.configuration)
    updatedField.validValues.configuration = {};
  if (!updatedField.fieldDefinition)
    updatedField.fieldDefinition = {};

  updatedField.validValues.method = method;

  const input =
    typeof apiOrValue === "string" || Array.isArray(apiOrValue)
      ? apiOrValue
      : { ...apiOrValue };

  switch (method) {
    case "PVV": {
      // PVV → API based value help
      updatedField.validValues.configuration.api = input;
      const optionName = getOptionName(input);
      updatedField.fieldDefinition.options = optionName || "";
      break;
    }

    case "API/Special services": {
      if (typeof input === "string") {
        updatedField.validValues.configuration.controlType = input;
      } else if (input?.configuration?.controlType) {
        updatedField.validValues.configuration.controlType =
          input.configuration.controlType;
      } else {
        console.warn("Unexpected API/Special services payload:", input);
      }

      if (input==='AdvancedLocationSearch' || input === 'AdvancedEquipmentSearch'){
        setIsBarcodeSelectionEnabled(true);
      } else {
        setIsBarcodeSelectionEnabled(false);
      }

      break;
    }

    case "Config": {
      updatedField.validValues.configuration.values = input;
      break;
    }

    default:
      console.warn("Unknown method:", method, "Payload:", input);
  }

  fieldReference.current = updatedField;

  setField(updatedField);

  handleMouseOut();
  closeModal();

  console.log("Field after assignment:", updatedField);
};

useEffect(() => {
  if (changedValue) {
    handleMouseOut();
  }
}, [field]);


  const handleAdddependent = () => {
    // setdependentEnabled(true);
    setdependentModalOpen(true);
  };

  const handleAddConfig = () => {
    // setdependentEnabled(true);
    console.log("Add config!");
    setConfigModalOpen(true);
  };


  const handleAddOption = () => {
    setOptionsModalOpen(true);
  };

  const handleAddTable = () => {
    console.log("Add table clicked!");
    setTableModalOpen(true);
  };

  const handleAddMessageStrip = () => {
    setMessageStripModalOpen(true);
  };

  const handleAddVisibility = () => {
    setFieldVisibilityModalOpen(true);
  };

  const submitdependent = (dependent) => {
    console.log("Submitted dependent is:", dependent);
    setChangedValue(true);

    setField(prev => {
      // Clone previous field safely
      const updatedField = { ...prev };

      // Ensure 'visible' object exists
      if (!updatedField.visible || typeof updatedField.visible !== "object") {
        updatedField.visible = {};
      }

      // Ensure 'dependent' array exists and replace it with the new one
      updatedField.visible.dependent = Array.isArray(updatedField.visible.dependent)
        ? [...updatedField.visible.dependent]
        : [];

      // Assign or replace dependent data
      updatedField.visible.dependent = [dependent];

      console.log("Field after adding dependent:", updatedField);

      // ✅ Update the reference immediately with the latest field
      fieldReference.current = updatedField;

      // Return the same updated object for state
      return updatedField;
    });

    setdependentEnabled(false);
    handleMouseOut();
  };

  const removedependent = () => {
    console.log("Removing dependent...");
    setChangedValue(true);

    setField(prev => {
      // Clone previous field safely
      const updatedField = { ...prev };

      // Ensure 'visible' object exists
      if (!updatedField.visible || typeof updatedField.visible !== "object") {
        updatedField.visible = {};
      }

      // Ensure dependent array exists, otherwise default safely
      updatedField.visible.dependent = Array.isArray(updatedField.visible.dependent)
        ? [...updatedField.visible.dependent]
        : [];

      // Remove dependent
      delete updatedField.visible.dependent;

      console.log("Field after removing dependent:", updatedField);

      // Update reference
      fieldReference.current = updatedField;

      return updatedField;
    });

    setdependentEnabled(false);
    closeModal();
    handleMouseOut();
  };

const submitMessageStrip = (messageStrip) => {
  debugger
  console.log("Submitted message strip:", messageStrip);
  setChangedValue(true);



  // 1️⃣ Clone the latest field safely
  const updatedField = { ...field };

  // 2️⃣ Ensure fieldDefinition exists
  if (!updatedField.fieldDefinition || typeof updatedField.fieldDefinition !== "object") {
    updatedField.fieldDefinition = {};
  }

  if (updatedField.messageStrip){
    delete updatedField.messageStrip;
  }

  // 3️⃣ Assign message strip inside fieldDefinition
  updatedField.fieldDefinition.messageStrip = messageStrip;

  // 4️⃣ Update reference immediately
  fieldReference.current = updatedField;

  // 5️⃣ Update React state
  setField(updatedField);

  // 6️⃣ Close modal
  setMessageStripModalOpen(false);

  // 7️⃣ After update
  handleMouseOut();

  console.log("Field after message strip update:", updatedField);
};


  const removeMessageStrip = () => {
    console.log('Removing message strip');
    delete field['messageStrip'];
    closeModal();
  };
  
  
  

  const handleMouseEnterMain = () => {
    // setIsEdit(true);
  };
  
  const handleMouseOutMain = () => {
    // setIsEdit(false);
  };

  const toggleEditArrow = () => {
    setIsArrowDown(!isArrowDown);
  };

  const handleExtrasOnInput = (field) => {
    if(['dropdown','selection'].includes(field.fieldDefinition.type)){
      // setCurrentMethod(field?.validValues?.method);
      setCurrentMethod(field?.fieldDefinition?.method || '');
      setOptionsEnabled(true);
    };
    if(['table'].includes(field.fieldDefinition.type)){
      setTableEnabled(true);
    };
    if(['multiCheckbox'].includes(field.fieldDefinition.type)){
      setMultiCheckBoxEnabled(true);
    };
    if(['staticContent'].includes(field.fieldDefinition.type)){
      setConfigEnabled(true);
    };
    if (['upload'].includes(field.fieldDefinition.type)) {
      setIsUpload(true);
      if (fieldTemplate.fieldDefinition.url === undefined) {
        fieldTemplate.fieldDefinition['url'] = '';
        fieldTemplate.fieldDefinition['area'] = '';
      };
    } else {
      delete fieldTemplate.fieldDefinition['url'];
      delete fieldTemplate.fieldDefinition['area'];
      // delete field['url'];
      // delete field['area'];
      setIsUpload(false);
    };

    if (field?.validValues?.configuration?.controlType==='AdvancedLocationSearch' || field?.validValues?.configuration?.controlType === 'AdvancedEquipmentSearch' ){
      setIsBarcodeSelectionEnabled(true);
    };

    if (field.fieldDefinition.type === 'table') {
      setTableEnabled(true);
    };

  };

  const handleSubmitTableColumns = (tableColumns) => {
    console.log("tableColumns: ", tableColumns);
    if (tableColumns.length > 0) {
      field.tableColumns = tableColumns;
    } else {
      delete field['tableColumns']
    }
  };

  const handleOpenMultiCheckBoxModal = () => {
    setMultiCheckBoxInputModalOpen(true);
  };
  
  const handleCloseMultiCheckBoxModal = () => {
    setMultiCheckBoxInputModalOpen(false);
  };
  
  const handleMultiCheckBoxSubmit = (selectedOptions) => {
    console.log("Selected MultiCheckbox Options: ", selectedOptions);
    // Handle the submitted data from MultiCheckBoxInputs here
  };  

  const handleMultiCheckBoxInputSubmit = (multiCheckBoxInputs) => {
    console.log("multiCheckBoxInputs: ", multiCheckBoxInputs);
    setChangedValue(true);
    if (multiCheckBoxInputs.length > 0) {
      field.multiCheckBoxInputs = multiCheckBoxInputs;
    } else {
      delete field['multiCheckBoxInputs']
    }
    handleMouseOut();
  };

  const submitFieldConfig = (config) => {
    console.log("field config: ", config);
    setChangedValue(true);
    field['config'] = config;
    handleMouseOut();
  };

  const removeFieldConfig = (config) => {
    console.log("Deleting field cofig");
    delete field['config'];
  };

  const handleInputChangeUrl = (event) => {
    console.log(event.target.value);
    field.url = event.target.value;
  };

  const handleInputChangeFieldDescription = (event) => {
    setFieldDescription(event.target.value);
  };

  const checkForErrorsInField = (field) => {
    // const fieldErrorKeys = validationService.fieldWithError(field);
    const fieldValidationResponse = validationService.validateField(field);
    console.log('field keys with erros: ', fieldValidationResponse.errorKeys);
    if (fieldValidationResponse.errorKeys.length > 0) {
      setFieldKeysWithError(fieldValidationResponse.errorKeys);
      return false;
    }
    setFieldKeysWithError([]);
    return true;
  };

  const setAlertMessageAndPopupFields  = (alertObject) => {
    setDisplayAlert(true);
    setAlertMessage(alertObject.message);
    setAlertType(alertObject.type);
    setTimeout(() => setDisplayAlert(false), 10000);
  }

  const openDeleteModal = (index) => {
    setIsDeleteModalOpen(true);
  };

  const handleMethodChange = (e) => {
    console.log(e.target.value);
  };

  const handleFieldVisibilityModalOpen = (e) => {
    setFieldVisibilityModalOpen(true);
  };

const submitVisibilityIntoField = (visibilityObject) => {
  console.log("visibilityObject:", visibilityObject);
  setChangedValue(true);

  const updatedField = { ...field};

  if (!updatedField.visible || typeof updatedField.visible !== "object") {
    updatedField.visible = {};
  }


  updatedField.visible.userStatus = visibilityObject || [];

  fieldReference.current = updatedField;
  setField(updatedField);

  handleMouseOut();

  console.log("Field after visibility:", updatedField);
};


const submitTableIntoFields = (tableFields) => {
  console.log("Submitted table fields:", tableFields);
  setChangedValue(true);

  // 1️⃣ Clone the latest field safely from reference or fallback
  const updatedField = { ...field } ;

  // 2️⃣ Ensure `fieldDefinition` structure exists
  if (!updatedField.fieldDefinition || typeof updatedField.fieldDefinition !== "object") {
    updatedField.fieldDefinition = {};
  }

  // 3️⃣ Initialize or update `tableFields` array
  updatedField.fieldDefinition.tableFields = Array.isArray(tableFields)
    ? [...tableFields]
    : [];

  // 4️⃣ Update the ref immediately (synchronous)
  fieldReference.current = updatedField;

  // 5️⃣ Update React state (asynchronous)
  setField(updatedField);

  // 6️⃣ Post-update UI actions
  setTableModalOpen(false);
  handleMouseOut();

  console.log("Field after adding table fields:", updatedField);
};

  

  return (
    <div className = {classes.FormFieldContainerWithError}>
       {(!isForm && !isTableField) && 
       <Toolbar
          sx={{
              backgroundColor: 'white',
              borderRadius: "10px",
              borderEndEndRadius: '0px',
              borderEndStartRadius: '0px',
              padding: '0px',
              color: 'white',
              position: 'sticky',
              top: 0,
              zIndex: 1000,
              justifyContent: 'space-between',
          }}
          >
              <>
              <Box sx={{ display: 'flex', flexGrow: 1}}>


              </Box>
              <Box>
              <Button
                  sx = {updateButtonStyle}
                  color="inherit"
                  startIcon={<SaveAltIcon />}
                  onClick={handleSubmitField}
              >
                  Save
              </Button>
                
              <Button
                  sx = {{...updateButtonStyle, mr: '-25px'}}
                  color="inherit"
                  startIcon={<KeyboardBackspaceIcon />}
                  onClick={props.handleClose}
              >
                  Back
              </Button>
              </Box>
              </>
        </Toolbar>}
      {
        displayAlert &&
        <CustomAlert isOpen={displayAlert} message={alertMessage} type={alertType}></CustomAlert>
      }
      {
        isDeleteModalOpen &&
        <DeleteConfirmation
          isOpen={isDeleteModalOpen}
          handleClose={()=> setIsDeleteModalOpen(false)}
          submitDelete={handleRemoveField}
          message = { 'Are you sure you want to remove this field?'}
          isRemove = {true}
        />
      }

    <div className={ utilityFunctions.isEven(props.indexFieldArray) ?  classes.FormFieldContainerTop2 : classes.FormFieldContainerTop1 }>
      <div style={{ position: 'relative', marginBottom: '20px', marginLeft: '3px', marginTop: "-5px" }}>
      <IconButton
            sx={toggleEditArrowCSS}
            edge="end" // Keeps alignment consistent with positioning
            color="inherit"
            aria-label="menu"
            onClick={toggleEditArrow}
          >
            <MoreHorizIcon sx={{ fontSize: 35 }} />
          </IconButton>
      </div>
      <div className={isArrowDown ? classes.FormFieldContainerVertical : classes.FormFieldContainer} >
      {fieldKeys.map((key, index) => (
        <div
          key={index}
          className={((['name', 'label', 'type', 'dataType', 'required', 'url', 'area','description', 'method'].includes(key) && !isArrowDown) || isArrowDown)
            ? classes.Field
            : classes.ClassesNone}
        >
          <InputLabel sx={{ mt: 1, mb: 1 }}>
            {convertToCapital(key)} {mandatoryFieldKeys.includes(key) && <span style={{ color: 'red' }}>*</span>}
          </InputLabel>
          <div>
            {
            key === 'barcode' ?
                <FormControlLabel
                  disabled={!isBarcodeSelectionEnabled}
                  control={
                    <Checkbox
                      name={key}
                      checked={field?.fieldDefinition?.[key]}
                      onChange={handleCheckboxChange}
                      onMouseOut={handleMouseOut}
                      sx={{
                        p: 0,
                        m: 0,
                        ml: '2px',
                        height: '10px',
                        width: '10px',
                        '& .MuiSvgIcon-root': { fontSize: '30px' },
                        borderColor: fieldKeysWithError.includes(key) ? 'red' : 'inherit',
                      }}
                    />
                  }
                  sx={{ m: 0, ml: '5px', p: 0 }}
                />: 
            (fieldTemplate.fieldDefinition[key] === 'boolean' && key!=='barcode')? (
              <FormControlLabel
                control={
                  <Checkbox
                    name={key}
                    checked={field?.fieldDefinition?.[key]}
                    onChange={handleCheckboxChange}
                    onMouseOut={handleMouseOut}
                    sx={fieldCheckboxFieldStyle(fieldKeysWithError)}
                  />
                }
                sx={{ m: 0, ml: '5px', p: 0 }}
              />
            ) : fieldTemplate.fieldDefinition[key] === 'number' && key === 'length' ? (
              <TextField
                type="text"
                name={key}
                value={field?.fieldDefinition?.[key]}
                onChange={handleInputChange}
                onBlur={handleMouseOut}
                variant="outlined"
                size="medium"
                disabled={optionsEnabled}
                sx={fieldInputFieldStyle(fieldKeysWithError)}
              />
            ) : fieldTemplate.fieldDefinition[key] === 'number' ? (
              <TextField
                type="number"
                name={key}
                value={field?.fieldDefinition?.[key]}
                onChange={handleInputChange}
                onBlur={handleMouseOut}
                variant="outlined"
                size="medium"
                sx={fieldInputFieldStyle(fieldKeysWithError)}
              />
            ) :  key === 'options' ? (
              <TextField
                disabled = {true}
                type="text"
                name={key}
                value={field?.fieldDefinition?.[key]}
                onChange={handleInputChange}
                onBlur={handleMouseOut}
                variant="outlined"
                size="medium"
                sx={fieldInputFieldStyle(fieldKeysWithError)}
              />
            ) : fieldTemplate.fieldDefinition[key] === 'select' && key === 'type' ? (
              <FormControl
                variant="outlined"
                className={classes.Select}
                sx={{
                  minWidth: '100%',
                  '& .MuiOutlinedInput-root': {
                    border: fieldKeysWithError.includes(key) ? '1px solid red' : 'inherit',
                  },
                }}
              >
                <Select
                  name={key}
                  value={field?.fieldDefinition?.[key] || ''}
                  onChange={handleInputChange}
                  onBlur={handleMouseOut}
                  sx={{ height: '40px', backgroundColor: 'white' }}
                >
                  {Object.keys(typeOptions).map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : fieldTemplate.fieldDefinition[key] === 'select' && key === 'validate' ? (
              <FormControl
                variant="outlined"
                className={classes.Select}
                sx={{
                  minWidth: '100%',
                  '& .MuiOutlinedInput-root': {
                    border: fieldKeysWithError.includes(key) ? '1px solid red' : 'inherit',
                  },
                }}
              >
                <Select
                  name={key}
                  value={field?.fieldDefinition?.[key]?.type || ''}
                  onChange={handleInputChange}
                  onBlur={handleMouseOut}
                  sx={{ height: '40px', backgroundColor: 'white' }}
                >
                  {validationValues.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : fieldTemplate.fieldDefinition[key] === 'select' && key === 'dataType' ? (
              <FormControl
                variant="outlined"
                className={classes.Select}
                sx={{
                  minWidth: '100%',
                  '& .MuiOutlinedInput-root': {
                    border: fieldKeysWithError.includes(key) ? '1px solid red' : 'inherit',
                  },
                }}
              >
                <Select
                  name={key}
                  value={field?.fieldDefinition?.[key] || ''}
                  onChange={handleInputChange}
                  onBlur={handleMouseOut}
                  disabled={optionsEnabled || tableEnabled}
                  sx={{ height: '40px', backgroundColor: 'white' }}
                >
                  {typeOptions[field?.fieldDefinition?.type]?.map((option) => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : fieldTemplate.fieldDefinition[key] === 'select' && key === 'controlType' ? (
              <FormControl
                variant="outlined"
                className={classes.Select}
                sx={{
                  minWidth: '100%',
                  '& .MuiOutlinedInput-root': {
                    border: fieldKeysWithError.includes(key) ? '1px solid red' : 'inherit',
                  },
                }}
              >
                <Select
                  name={key}
                  value={field?.fieldDefinition?.[key] || ''}
                  onChange={handleInputChange}
                  onBlur={handleMouseOut}
                  disabled={disableControlType}
                  sx={{ height: '40px', backgroundColor: 'white' }}
                >
                  {Object.keys(controlTypeValues).map((controlTypeKey) => (
                    <MenuItem key={controlTypeKey} value={controlTypeValues[controlTypeKey]}>
                      {controlTypeKey}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : fieldTemplate.fieldDefinition[key] === 'url' ? (
              <TextField
                type="text"
                name={key}
                value={field?.fieldDefinition?.[key] ? field?.fieldDefinition?.[key] : ''}
                onChange={handleInputChangeUrl}
                onBlur={handleMouseOut}
                disabled={true}
                variant="outlined"
                size="medium"
                sx={fieldInputFieldStyle(fieldKeysWithError)}
              />
            ) : key === 'dependent' ? (
              <TextField
                type="text"
                name={key}
                value={field?.fieldDefinition?.[key] ? field?.fieldDefinition?.[key][0]?.field : ''}
                onChange={handleInputChangeUrl}
                onBlur={handleMouseOut}
                disabled={true}
                variant="outlined"
                size="medium"
                sx={fieldInputFieldStyle(fieldKeysWithError)}
              />
            ) : key === 'method' ? 
            (
              <FormControl
              variant="outlined"
              disabled = {!optionsEnabled}
              className={classes.Select}
              sx={{
                // display: optionsEnabled ? 'block' : 'none', 
                minWidth: '100%',
                '& .MuiOutlinedInput-root': {
                  border: fieldKeysWithError.includes('method') ? '1px solid red' : 'inherit',
                },
              }}
            >
                <Select
                  name="method"
                  value={field?.fieldDefinition?.method || ''}
                  onChange={handleInputChange}
                  onBlur={handleMouseOut}
                  sx={{ height: '40px', backgroundColor: 'white' }}
                >
                  <MenuItem value="">
                    <em>Select Method</em>
                  </MenuItem>
                  <MenuItem value="Config">Config</MenuItem>
                  <MenuItem value="PVV">PVV</MenuItem>
                  <MenuItem value="API/Special services">API/Special services</MenuItem>
                </Select>
              </FormControl>
            )
              : (
              <TextField
                type="text"
                name={key}
                value={field?.fieldDefinition?.[key] || ''}
                onChange={handleInputChange}
                onBlur={handleMouseOut}
                variant="outlined"
                size="medium"
                sx={fieldInputCSS(fieldKeysWithError)}
              />
            )}
          </div>
        </div>
      ))}  
          {/* When its form show both save and delete and when it is table only shoe remove option */}
          {/* <div style={{ display: 'flex', justifyContent: 'flex-end', position: 'relative', flexGrow: '1' }}>
            {((isForm) && !isArrowDown) &&
              <div className={classes.ButtonDirection}>
                <Button
                  onClick={handleSubmitField}
                  sx={submitFieldCSS}
                >
                  <BackupIcon sx={{ fontSize: 30, marginTop: 1, marginBottom: '5px', color: 'var(--app-color)', padding: 0 }} />
                  <Typography sx={{ fontSize: 10, textTransform: 'none' }} variant="body2">Save Field</Typography>
                </Button>
                <Button
                  onClick={openDeleteModal}
                  sx={removeFieldCSS}
                >
                  <RemoveCircleIcon sx={{ fontSize: 30, marginTop: 1, marginBottom: '5px', color: 'red', padding: 0 }} />
                  <Typography sx={{ fontSize: 10, textTransform: 'none' }} variant="body2">Remove</Typography>
                </Button>
              </div>
            }

            {((isTableField) && !isArrowDown) &&
              <div className={classes.ButtonDirection}>
                <Button
                  onClick={handleRemoveFieldFromTableFields}
                  sx={removeFieldCSS}
                >
                  <RemoveCircleIcon sx={{ fontSize: 30, marginTop: 1, marginBottom: '5px', color: 'red', padding: 0 }} />
                  <Typography sx={{ fontSize: 10, textTransform: 'none' }} variant="body2">Remove</Typography>
                </Button>
              </div>
            }

          </div> */}
      </div>
      {(!isOnlyReadAccess && !isView ) && (
        // <div className={ isForm  ? (isArrowDown ? classes.ButtonDirection : classes.ClassesNone) : classes.ButtonDirection}>
         <div className={ isForm  ? (true ? classes.ButtonDirection : classes.ClassesNone) : classes.ButtonDirection}>
        {/* New Action Buttons*/}
        {/* <FieldActionButton
          onClick={openDeleteModal}
          IconComponent={RemoveCircleIcon}
          label="Remove"
          color="red"
        /> */}
        {/* <FieldActionButton
          onClick={handleSubmitField}
          IconComponent={BackupIcon}
          label="Save Field"
        /> */}
        <FieldActionButton
          onClick={handleAdddependent}
          IconComponent={LowPriorityIcon}
          label="Dependent"
        />
        <FieldActionButton
          onClick={handleAddMessageStrip}
          IconComponent={MessageIcon}
          label="Message Strip"
        />
        <FieldActionButton
          onClick={handleAddConfig}
          IconComponent={DataObjectIcon}
          label="Config"
          visibilityControl= {configEnabled}
        />

        <FieldActionButton
          onClick={handleAddOption}
          IconComponent={StyleIcon}
          label="Options"
          visibilityControl= {optionsEnabled}
        />
        <FieldActionButton
          onClick={handleAddTable}
          IconComponent={FormatListNumberedIcon}
          label="Table"
          visibilityControl= {tableEnabled}
        />
        <FieldActionButton
          onClick={handleOpenMultiCheckBoxModal}
          IconComponent={AutoAwesomeMotionIcon}
          label="MultiCheck"
          visibilityControl= {multiCheckBoxEnabled}
        />
        <FieldActionButton
          onClick={handleFieldVisibilityModalOpen}
          IconComponent={VisibilityOutlined}
          label="Visibility"
        />
          {/* <div style={{ display: 'flex', justifyContent: 'flex-end', position: 'relative', flexGrow: '1'}}>
           */}
            {((isForm) && !isArrowDown) &&
             <div style={{ display: 'flex', flexDirection: 'row' }}>
                <Button
                  onClick={handleSubmitField}
                  sx={submitFieldCSS}
                >
                  <BackupIcon sx={{ fontSize: 30, marginTop: 1, marginBottom: '5px', color: 'var(--app-color)', padding: 0 }} />
                  <Typography sx={{ fontSize: 10, textTransform: 'none' }} variant="body2">Save Field</Typography>
                </Button>
                <Button
                  onClick={openDeleteModal}
                  sx={removeFieldCSS}
                >
                  <RemoveCircleIcon sx={{ fontSize: 30, marginTop: 1, marginBottom: '5px', color: 'red', padding: 0 }} />
                  <Typography sx={{ fontSize: 10, textTransform: 'none' }} variant="body2">Remove</Typography>
                </Button>
              </div>
            }

            {((isTableField) && !isArrowDown) &&
                <Button
                  onClick={handleRemoveFieldFromTableFields}
                  sx={removeFieldCSS}
                >
                  <RemoveCircleIcon sx={{ fontSize: 30, marginTop: 0, marginBottom: '5px', color: 'red', padding: 0 }} />
                  <Typography sx={{ fontSize: 10, textTransform: 'none' }} variant="body2">Remove</Typography>
                </Button>
            }

          {/* </div> */}
        {/* New Action Buttons*/}

          {optionsModalOpen && (
            <>
              {currentMethod === 'PVV' && (
                <FieldOptionsSelector
                  isOpen={optionsModalOpen}
                  handleClose={() => setOptionsModalOpen(false)}
                  submitOption={submitOptionsIntoField}
                  field={field}
                />
              )}

              {currentMethod === 'API/Special services' && (
                <FieldControlTypeSelector
                  isOpen={optionsModalOpen}
                  handleClose={() => setOptionsModalOpen(false)}
                  onSubmit={submitOptionsIntoField}
                  initialControlType={field?.validValues?.configuration?.controlType || ""}
                />
              )}

              {currentMethod === 'Config' && 
                <FieldValidValuesBuilder
                  isOpen={optionsModalOpen}
                  handleClose={() => setOptionsModalOpen(false)}
                  onSubmit={submitOptionsIntoField}
                  initialValidValues={field?.validValues?.configuration?.values || []}
                />
              }
            </>
          )}
          {dependentModalOpen && <FieldsDependentSelector
            isOpen={dependentModalOpen}
            handleClose={closeModal}
            submitdependent={submitdependent}
            removedependent={removedependent}
            dependent={field?.visible?.dependent || undefined}
          />}

           {messageStripModalOpen && (
            <MessageStrip
              // strip={{ values: messageStrips }}  // Pass current message strips as props
              // isEdit={messageStrips.length > 0}  // Pass isEdit flag
              messageStrip = {field?.fieldDefinition?.messageStrip || null}
              isOpen = {messageStripModalOpen}
              handleClose={closeModal}
              isEdit = {false}
              submitMessageStrips={submitMessageStrip}  // Pass submit function
              removeMessageStrip={removeMessageStrip}  // Pass remove function
            />
          )}
          {
            configModalOpen &&
            <FieldConfigBuilder
              isOpen={configModalOpen}
              handleClose={closeModal}
              onSubmit={submitFieldConfig}
              onRemove={removeFieldConfig}
              fieldConfig={field?.config || null}
            />
          }

        {/* <TableColumns
          open={tableModalOpen} // Use "open" instead of "isOpen"
          onClose={closeModal} // Use "onClose" instead of "handleClose"
          onSubmit={handleSubmitTableColumns} // "onSubmit" is correct
          tableColumnsInput = {field.tableColumns || []}
        /> */}


        
        <TableFieldsPopup
          open={tableModalOpen}
          onClose={closeModal}
          onSubmit={submitTableIntoFields}
          tableFields={ field?.fieldDefinition?.tableFields || []}
        />

        <MultiCheckBoxInputs
          open={multiCheckBoxInputModalOpen}
          onClose={closeModal}
          onSubmit={handleMultiCheckBoxInputSubmit}
          multiCheckBoxInputsInput = {field?.multiCheckBoxInputs || []} // Replace with your dynamic options
        />
          {fieldVisibilityModalOpen && (
            <FieldVisibilitySelector
              isOpen={fieldVisibilityModalOpen}
              handleClose={closeModal}
              onSubmit={submitVisibilityIntoField}
              fieldVisibility={field?.visible?.userStatus || []}
            />
          )}

      </div>
      )}
    </div>

    </div>
  );
};

export default memo(FieldBuilder);
